export default __webpack_public_path__ + "app-install-error.f23c1d8481b72715814f1982b3c83842.svg";